<main class="agpr-targetingResults" #overlayContainer>
    <section
        class="agpr-targetingResults-center"
        [agprLoading]="
            (searchLoading && !targetingSearchService.mapView) ||
            deleteLoading ||
            removeFromListLoading
        "
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <header>
            <h2
                class="agpr-targetingResults-heading"
                [ngClass]="{
                    'agpr-targetingResults-heading--visible': pageHeader
                }"
            >
                <span *ngIf="pageHeader">{{ pageHeader }}</span
                >&nbsp;
                <span *ngIf="pageSrHeader" class="u-srOnly">{{
                    pageSrHeader | localize
                }}</span>
                <span *ngIf="!pageHeader" class="u-srOnly">{{
                    "Discover.targeting.searchResults" | localize
                }}</span>
            </h2>
        </header>
        <div
            class="agpr-targetingResults-topLockBar"
            role="group"
            [attr.aria-label]="'Discover.targeting.toolbarControls' | localize"
            [agprLoading]="filtersLoading"
        >
            <!-- top row-->
            <h3 class="u-srOnly">{{ "toolbar" | localize }}</h3>
            @if (!targetingSearchService.mapView) {
                <div
                    class="agpr-targetingResults-toolbar agpr-targetingResults-toolbar--top"
                    [@toolbarCollapsed]="
                        toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled
                    "
                    (@toolbarCollapsed.start)="onAnimationStart($event)"
                    (@toolbarCollapsed.done)="onAnimationDone($event)"
                >
                    <div
                        class="agpr-targetingResults-toolbarColumn agpr-targetingResults-toolbarColumn--left agpr-targetingResults-toolbarColumn--noPadding agpr-targetingResults-toolbarColumn--noBorder agpr-targetingResults-toolbarColumn-filter"
                    >
                        <agpr-filter-dropdown
                            [id]="id + '.filters'"
                            class="agpr-targetingResults-toolbar-dropdown"
                            [showQuickFilter]="true"
                            quickFilterPlaceholder="Discover.targeting.filter.quick.contactName.placeholder"
                            [ariaLabel]="'Discover.targeting.filter.quick.label' | localize"
                            [ariaDescribedBy]="id + '.chips'"
                        >
                        </agpr-filter-dropdown>
                    </div>
                    <div
                        class="agpr-targetingResults-toolbarColumn agpr-targetingResults-toolbar-chips"
                    >
                        <agpr-filter-chips
                            [id]="id + '.chips'"
                            #filterChipsComponent
                        ></agpr-filter-chips>

                        <!--
                            TODO - we use _ now ...
                            we have to use '-' instead of '.' here for the ID because the css does not allow us to select the ID when a '.' is used,
                            the results is that the button is never visible, because it only shows on "&:hover ::ng-deep #ID"
                        -->
                        <agpr-button
                            [id]="id + '-filterClear'"
                            *ngIf="filterChipsComponent.chips.length > 1"
                            class="agpr-targetingResults-toolbarIcon-clear"
                            [style]="buttonTypes.icon"
                            (click)="clearFilters()"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Discover.targeting.filter.tooltip.clearAll"
                            tooltipPosition="top"
                        ></agpr-button>
                        <agpr-button
                            [id]="id + '.filterLock'"
                            [ngClass]="{
                                'agpr-targetingResults-toolbarIcon--lock':
                                    filtersLocked,
                                'agpr-targetingResults-toolbarIcon--unlock':
                                    !filtersLocked
                            }"
                            class="agpr-targetingResults-toolbarIconButton"
                            [style]="buttonTypes.icon"
                            (click)="
                                targetingSearchService.setFiltersLocked(
                                    !filtersLocked
                                )
                            "
                            [icon]="
                                filtersLocked
                                    ? 'fa-regular fa-duotone fa-lock'
                                    : 'fa-regular fa-duotone fa-unlock'
                            "
                            [tooltip]="
                                filtersLocked
                                    ? 'Discover.targeting.filter.tooltip.unlock'
                                    : 'Discover.targeting.filter.tooltip.lock'
                            "
                            tooltipPosition="top"
                        ></agpr-button>
                    </div>

                    <agpr-sort-order
                        [id]="id + '.sortOrder'"
                        class="agpr-targetingResults-toolbar-sortOrder"
                        [isDisabled]="!results?.length"
                        tooltip="Discover.targeting.tooltips.sort"
                        optionKey="enumValue"
                        optionLabel="displayString"
                    ></agpr-sort-order>

                    <div
                        class="agpr-targetingResults-toolbar-viewButtons"
                        [ngClass]="{
                            'agpr-targetingResults-toolbarColumn': true,
                            'agpr-targetingResults-toolbarColumn--top': true,
                            'agpr-targetingResults-toolbar-padding':
                                targetingSearchService.mapView
                        }"
                    >
                        <agpr-slide-toggle
                            [options]="viewModeOptions"
                            [ngModel]="selectedViewMode"
                            (ngModelChange)="viewModeChanged($event)"
                        ></agpr-slide-toggle>
                    </div>
                </div>
            }

            <div
                class="agpr-targetingResults-toolbar agpr-targetingResults-toolbar--middle"
                *ngIf="!targetingSearchService.mapView"
                [@toolbarCollapsed]="
                    toolbarStateService.toolbarCollapsed && !toolbarStateService.toolbarAnimationDisabled
                "
                (@toolbarCollapsed.start)="onAnimationStart($event)"
                (@toolbarCollapsed.done)="onAnimationDone($event)"
            >
                <span class="agpr-targetingResults-listBuilder">
                    <div class="agpr-targetingResults-listBuilder-addTo">
                        {{ "Targeting.add.to" | localize }}
                    </div>
                    <agpr-dropdown
                        [id]="id + '.targeting.add.to.type'"
                        class="agpr-targetingResults-listBuilder-type"
                        [options]="targetingAddToOptions"
                        [(ngModel)]="addToType"
                        [bindToValue]="true"
                        (ngModelChange)="selectTargetingType()"
                    ></agpr-dropdown>

                    @if (addToType === targetingAddToTypes.LIST) {
                    <agpr-autocomplete
                        [id]="id + '.listBuilderDropdown'"
                        #listBuilderDropdown
                        class="agpr-targetingResults-listBuilder-dropdown"
                        labelField="name"
                        placeholder="Discover.listBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [customOptions]="listBuilderOptions"
                        [(ngModel)]="selectedLists"
                        (itemSelected)="updateListBuilder()"
                        [suggestions]="targetingLists$"
                        [multiSelection]="true"
                        [pTooltip]="
                            'Discover.listBuilder.widget.tooltip.dropdown'
                                | localize
                        "
                        tooltipPosition="top"
                        selectedItemsHideKey="id"
                        [ariaLabel]="
                            'Discover.listBuilder.widget.placeholder.dropdown'
                        "
                        [showHiddenOption]="true"
                    ></agpr-autocomplete>
                    <span class="agpr-targetingResults-listBuilder-chips">
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '.selectedLists.chips'"
                            [chips]="selectedListsChips"
                            (removeChip)="
                                listPickerService.removeWorkingListByIndex(
                                    $event
                                )
                            "
                        ></agpr-chip-container>
                        <agpr-button
                            *ngIf="selectedLists.length > 1"
                            [id]="id + '-listBuilderClear'"
                            class="agpr-targetingResults-toolbarIcon-clear"
                            [style]="buttonTypes.icon"
                            (click)="clearListChips()"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Discover.listBuilder.widget.tooltip.clearAll"
                            tooltipPosition="top"
                        ></agpr-button>
                        <agpr-button
                            [id]="id + '.listBuilder.lock'"
                            [ngClass]="{
                                'agpr-targetingResults-toolbarIcon--lock':
                                    workingListsLocked,
                                'agpr-targetingResults-toolbarIcon--unlock':
                                    !workingListsLocked
                            }"
                            class="agpr-targetingResults-toolbarIconButton"
                            [style]="buttonTypes.icon"
                            (click)="listPickerService.toggleWorkingListsLock()"
                            [icon]="
                                workingListsLocked
                                    ? 'fa-regular fa-duotone fa-lock'
                                    : 'fa-regular fa-duotone fa-unlock'
                            "
                            [tooltip]="
                                workingListsLocked
                                    ? 'Discover.listBuilder.widget.tooltip.unlock'
                                    : 'Discover.listBuilder.widget.tooltip.lock'
                            "
                            tooltipPosition="top"
                        ></agpr-button>
                    </span>
                    } @else {
                    <agpr-autocomplete
                        [id]="id + '.distributionBuilderDropdown'"
                        #listBuilderDropdown
                        class="agpr-targetingResults-listBuilder-dropdown"
                        labelField="name"
                        placeholder="Discover.distributionBuilder.widget.placeholder.dropdown"
                        [dropdown]="true"
                        dropdownMode="current"
                        [(ngModel)]="selectedDistributions"
                        (itemSelected)="updateDistributionBuilder()"
                        [suggestions]="distributions$"
                        [multiSelection]="true"
                        [pTooltip]="
                            'Discover.distributionBuilder.widget.tooltip.dropdown'
                                | localize
                        "
                        tooltipPosition="top"
                        selectedItemsHideKey="id"
                        [ariaLabel]="
                            'Discover.distributionBuilder.widget.placeholder.dropdown'
                        "
                        [showHiddenOption]="true"
                    ></agpr-autocomplete>

                    <span class="agpr-targetingResults-listBuilder-chips">
                        <agpr-chip-container
                            #listChipsComponent
                            [id]="id + '.selectedDistributions.chips'"
                            [chips]="selectedDistributionsChips"
                            (removeChip)="removeDistribution($event)"
                        ></agpr-chip-container>
                        <agpr-button
                            *ngIf="selectedDistributions.length > 1"
                            [id]="id + '-distributionBuilderClear'"
                            class="agpr-targetingResults-toolbarIcon-clear"
                            [style]="buttonTypes.icon"
                            (click)="clearDistributionChips()"
                            icon="fa-kit-duotone fa-agpr-remove-all"
                            tooltip="Discover.distributionBuilder.widget.tooltip.clearAll"
                            tooltipPosition="top"
                        ></agpr-button>
                        <agpr-button
                            [id]="id + '.distributionBuilder.lock'"
                            [ngClass]="{
                                'agpr-targetingResults-toolbarIcon--lock':
                                    workingDistributionsLocked,
                                'agpr-targetingResults-toolbarIcon--unlock':
                                    !workingDistributionsLocked
                            }"
                            class="agpr-targetingResults-toolbarIconButton"
                            [style]="buttonTypes.icon"
                            (click)="
                                distributionPickerService.toggleWorkingDistributionsLock()
                            "
                            [icon]="
                                workingDistributionsLocked
                                    ? 'fa-regular fa-duotone fa-lock'
                                    : 'fa-regular fa-duotone fa-unlock'
                            "
                            [tooltip]="
                                workingDistributionsLocked
                                    ? 'Discover.distributionBuilder.widget.tooltip.unlock'
                                    : 'Discover.distributionBuilder.widget.tooltip.lock'
                            "
                            tooltipPosition="top"
                        ></agpr-button>
                    </span>
                    }
                </span>
                <agpr-button
                    [id]="id + '.addTo'"
                    class="agpr-targetingResults-listBuilder-addToButton"
                    [ngClass]="{
                        'agpr-targetingResults-listBuilder-addToDistButton':
                            addToType === targetingAddToTypes.DISTRIBUTION
                    }"
                    [style]="buttonTypes.icon"
                    [icon]="
                        addToType === targetingAddToTypes.LIST
                            ? 'fa-regular fa-duotone fa-user-plus'
                            : 'fa-kit-duotone fa-agpr-add-distribution'
                    "
                    [disabled]="
                        !results?.length || selectedResults.length === 0
                    "
                    (click)="addTo()"
                    [tooltip]="
                        addToType === targetingAddToTypes.LIST
                            ? 'Discover.listBuilder.widget.tooltip.addButton'
                            : 'Discover.distributionBuilder.widget.tooltip.addButton'
                    "
                    tooltipPosition="top"
                ></agpr-button>
                <!-- [label]="selectedListsChips.length <= 1 ? 'Discover.listBuilder.widget.addButton': ''" -->
            </div>

            <!-- bottom row-->
            <div
                class="agpr-targetingResults-toolbar agpr-targetingResults-toolbar--bottom"
                [style.width]="toolbarStateService.toolbarCollapsed ? toolbarStateService.toolbarWidth + 'px' : '100%'"
            >
                <span class="agpr-targetingResults-selectToggle">
                    <agpr-checkbox
                        id="targetingResults_selectAll"
                        [binary]="true"
                        [ngModel]="
                            results?.length > 0 &&
                            selectedResults?.length === results?.length
                        "
                        (ngModelChange)="toggleSelectAll()"
                        [disabled]="!results?.length"
                        [label]="
                            allSelected
                                ? '' + total
                                : '' + (selectedResults?.length || '0')
                        "
                        hiddenLabel="selectAll"
                    ></agpr-checkbox>
                    <span class="agpr-targetingResults-totalCount">
                        <span class="agpr-targetingResults-totalCount-text">
                            {{ "Paginator.of" | localize }}
                        </span>
                        <span
                            class="agpr-targetingResults-totalCount-value"
                            *ngIf="!targetingSearchService.mapView"
                        >
                            {{ total }}
                        </span>
                        <span
                            class="agpr-targetingResults-totalCount-value"
                            *ngIf="targetingSearchService.mapView"
                        >
                            {{ mapViewTotal }}
                        </span>
                        <span class="agpr-targetingResults-totalCount-text">
                            {{
                                "Discover.targeting.searchTotalCount" | localize
                            }}
                        </span>
                    </span>
                </span>
                <div class="agpr-targetingResults-toolbarColumn">
                    <agpr-paginator
                        [id]="id + '.paginator'"
                        *ngIf="!targetingSearchService.mapView"
                        [targetingMode]="true"
                    ></agpr-paginator>
                </div>
                <div
                    *ngIf="targetingSearchService.mapView"
                    class="agpr-targetingResults-toolbar-viewButtons"
                    [ngClass]="{
                        'agpr-targetingResults-toolbarColumn': true,
                        'agpr-targetingResults-toolbarColumn--top': true,
                        'agpr-targetingResults-toolbar-padding':
                            targetingSearchService.mapView
                    }"
                >
                    <agpr-slide-toggle
                        [options]="viewModeOptions"
                        [ngModel]="selectedViewMode"
                        (ngModelChange)="viewModeChanged($event)"
                    ></agpr-slide-toggle>
                </div>
            </div>
        </div>
        <div
            *ngIf="
                selectedResults?.length === results?.length &&
                total > selectedResults?.length &&
                !targetingSearchService.mapView
            "
            class="agpr-targetingResults-selectAllNotice"
        >
            <agpr-message [severity]="messageSeverityEnum.info">
                <span *ngIf="!allSelected">
                    {{
                        "Discover.targeting.result.selectAll.notice.page"
                            | localize
                                : {
                                      count: selectedResults.length
                                  }
                    }}
                </span>
                <span *ngIf="allSelected">
                    {{
                        "Discover.targeting.result.selectAll.notice.all"
                            | localize
                                : {
                                      count: total
                                  }
                    }}
                </span>
                <agpr-button
                    [id]="id + '.selectAll'"
                    *ngIf="!allSelected"
                    [label]="
                        'Discover.targeting.result.selectAll.hyperlink.select'
                            | localize
                                : {
                                      count: total
                                  }
                    "
                    (click)="selectAllResults()"
                    [style]="buttonTypes.link"
                    class="agpr-targetingResults-selectAllNotice-link"
                ></agpr-button>
                <agpr-button
                    [id]="id + '.clearSelectAll'"
                    *ngIf="allSelected"
                    label="Discover.targeting.result.selectAll.hyperlink.clear"
                    (click)="toggleSelectAll()"
                    [style]="buttonTypes.link"
                    class="agpr-targetingResults-selectAllNotice-link"
                ></agpr-button>
            </agpr-message>
        </div>
        <div
            *ngIf="listHasActiveNotices"
            class="agpr-targetingResults-hasActiveNotices"
        >
            <agpr-message [severity]="messageSeverityEnum.warning">
                {{
                    "Discover.targeting.result.activeNotices.listHasActiveNotices"
                        | localize
                }}

                <agpr-button
                    *ngIf="!activeNoticeFilterApplied"
                    [id]="id + '.applyActiveNoticeFilter'"
                    label="Discover.targeting.result.activeNotices.listHasActiveNotices.applyFilter"
                    (click)="applyActiveNoticeFilter()"
                    [style]="buttonTypes.link"
                    class="agpr-targetingResults-hasActiveNotices-link"
                ></agpr-button>
            </agpr-message>
        </div>
        <agpr-scroll-panel
            #listViewPanel
            (scrolledTopChange)="onScroll($event)"
        >
            <h3 class="u-srOnly">{{ "results" | localize }}</h3>
            <div
                class="agpr-targetingResults-contents"
                *ngIf="!targetingSearchService.mapView"
            >
                <h3
                    *ngIf="addedResults.length"
                    class="agpr-targetingResults-contents-resultHeading"
                >
                    {{ "Discover.targeting.result.newContact" | localize }}
                </h3>
                <div
                    *ngIf="addedResults.length"
                    class="agpr-targetingResults-contents-newContactContainer"
                >
                    <agpr-contact-card
                        *ngFor="let addedResult of addedResults; let i = index"
                        [id]="'targetingResults.' + i + '.addedContactCard'"
                        [disableSelection]="allSelected"
                        [entity]="addedResult"
                        [selectedResults]="selectedResults"
                        (focus)="cardFocused($event)"
                        (selectionChanged)="selectedResults = $event"
                        (showContactEditor)="contactEditorVisible = true"
                        [contextMenuTemplate]="listContextMenu"
                    ></agpr-contact-card>
                </div>

                <h3
                    *ngIf="addedResults.length"
                    class="agpr-targetingResults-contents-resultHeading"
                >
                    {{ "Discover.targeting.result.allContacts" | localize }}
                </h3>
                <ul
                    id="targetingResultList"
                    agprListKeyboardNavigation
                    [focusOnChild]="true"
                    [list]="results"
                    focusableElementCustomSelector=".agpr-targetingResults-card"
                >
                    <li
                        *ngFor="
                            let result of results;
                            let i = index;
                            trackBy: trackResult
                        "
                    >
                        <agpr-contact-card
                            *ngIf="result.entityType === entityTypes.CONTACT"
                            [id]="'targetingResults_' + i + '_contactCard'"
                            [disableSelection]="allSelected"
                            [addToType]="addToType"
                            [entity]="result"
                            [selectedResults]="selectedResults"
                            [initiallyFocusable]="i === 0"
                            (focus)="cardFocused($event)"
                            (selectionChanged)="selectedResults = $event"
                            (showContactEditor)="contactEditorVisible = true"
                            [contextMenuTemplate]="listContextMenu"
                            (employmentContextChanged)="
                                contactEmploymentChange($event)
                            "
                        >
                        </agpr-contact-card>
                        <agpr-outlet-card
                            *ngIf="result.entityType === entityTypes.OUTLET"
                            [id]="'targetingResults_' + i + '_outletCard'"
                            [disableSelection]="allSelected"
                            [addToType]="addToType"
                            [entity]="result"
                            [selectedResults]="selectedResults"
                            [initiallyFocusable]="i === 0"
                            (selectionChanged)="selectedResults = $event"
                            [contextMenuTemplate]="listContextMenu"
                        >
                        </agpr-outlet-card>
                    </li>
                </ul>
            </div>
            <ng-container
                *ngIf="
                    results?.length === 0 ||
                    (targetingSearchService.mapView &&
                        geocodeResults?.length === 0)
                "
            >
                <ng-container
                    *ngIf="targetingSearch !== null; else noMixedResult"
                >
                    <div
                        class="agpr-targetingResults-contents"
                        *ngIf="targetingSearch.searchMode == 'CONTACT'"
                    >
                        <agpr-message
                            [severity]="messageSeverityEnum.noContent"
                        >
                            <span>
                                {{
                                    "Discover.targeting.result.noContactsFound"
                                        | localize
                                }}
                            </span>
                        </agpr-message>
                    </div>
                    <div
                        class="agpr-targetingResults-contents"
                        *ngIf="targetingSearch.searchMode == 'OUTLET'"
                    >
                        <agpr-message
                            [severity]="messageSeverityEnum.noContent"
                        >
                            <span>
                                {{
                                    "Discover.targeting.result.noOutletsFound"
                                        | localize
                                }}
                            </span>
                        </agpr-message>
                    </div>
                </ng-container>
                <ng-template #noMixedResult>
                    <div class="agpr-targetingResults-contents">
                        <agpr-message
                            [severity]="messageSeverityEnum.noContent"
                        >
                            <span>
                                {{
                                    "Discover.targeting.result.noMixedFound"
                                        | localize
                                }}
                            </span>
                        </agpr-message>
                    </div>
                </ng-template>
            </ng-container>
        </agpr-scroll-panel>

        <div
            class="map-view"
            [ngClass]="{
                'agpr-hideMap':
                    !targetingSearchService.mapView ||
                    geocodeResults?.length === 0
            }"
        >
            <agpr-message
                *ngIf="rateLimitExceeded"
                [severity]="messageSeverityEnum.warning"
            >
                <span style="font-weight: bold">
                    {{
                        "Discover.targeting.mapView.rateLimit.exceeded.heading"
                            | localize
                    }}
                </span>
                {{
                    "Discover.targeting.mapView.rateLimit.exceeded.message"
                        | localize
                }}
            </agpr-message>
            @if (total >= maxValueOfContactForMapView){
                <div class="agpr-targetingResults-mapViewWarning">
                    <agpr-message [severity]="messageSeverityEnum.warning">
                        {{
                            "Discover.privateContacts.moreThan10k.warning"
                                | localize
                        }}
                    </agpr-message>
                </div>
                }
            <div class="agpr-map-container">
                <agpr-button
                    *ngIf="targetingSearchService.mapView && showMapResetButton"
                    [id]="id + '.mapView.restMapZoom'"
                    class="agpr-targetingResults-resetZoom"
                    (click)="resetZoom()"
                    [style]="buttonTypes.contextMenu"
                    tooltip="Discover.targeting.mapView.resetMap"
                >
                    <span
                        class="agpr-targetingResults-resetZoom-icon fa-regular fa-arrow-rotate-left"
                    ></span>
                </agpr-button>
                <div #mapContainer class="agpr-map"></div>
            </div>
        </div>

        @if (hasUnavailableOutlet) {
            <div
                class="agpr-targetingResults-center-warningMessage"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.warning"
                >
                    {{
                        "Discover.targeting.savedSearches.warningMessage.outlet.invalidOutlets"
                            | localize
                    }}
                    <a
                        class="agpr-message-warningMessageLink"
                        [href]="['/Discover/targetingsearches/search/' + targetingSearch?.id]"
                    >
                        {{
                            "Discover.targeting.savedSearches.warningMessage.outlet.editToSave"
                                | localize
                        }}
                    </a>
                    {{
                        "Discover.targeting.savedSearches.warningMessage.outlet.removePermanently"
                            | localize
                    }}
                </agpr-message>
            </div>
        }

        <agpr-action-bar [headingContext]="'results' | localize">
            <ng-template #left>
                <agpr-button
                    [id]="id + '.deleteSelected'"
                    *ngIf="
                        currentRoute?.type === routeType.privateContacts &&
                        selectedResults.length > 0
                    "
                    label="Core.button.delete"
                    [style]="buttonTypes.secondary"
                    (click)="deleteSelected()"
                ></agpr-button>
                <agpr-button
                    [id]="id + '.removeFromList'"
                    *ngIf="
                        currentRoute?.type ===
                            routeType.targetingListSearchResult &&
                        selectedResults.length > 0
                    "
                    label="Discover.targeting.actions.removeFromList.button"
                    [disabled]="selectedResults.length === 0"
                    [style]="buttonTypes.secondary"
                    (click)="confirmRemoveFromList()"
                ></agpr-button>
                <agpr-button
                    [id]="id + '.editSearch'"
                    *ngIf="
                        currentRoute?.type ===
                            routeType.targetingSavedSearchResults ||
                        currentRoute?.type === routeType.targetingResults
                    "
                    label="Discover.targeting.actions.editSearch"
                    [style]="buttonTypes.secondary"
                    (click)="editSearch()"
                ></agpr-button>
            </ng-template>
            <ng-template #right>
                <agpr-split-button
                    *ngIf="
                        !this.targetingSearchService.mapView &&
                        currentRoute?.type !== routeType.privateContacts
                    "
                    [style]="buttonTypes.primaryB"
                    [panelPositionY]="'top'"
                    [panelPositionX]="'right'"
                    [label]="'Discover.targeting.actions.actions'"
                    [options]="actions"
                ></agpr-split-button>
                <agpr-split-button
                    [id]="id + '.saveChangesOrSaveAsNew'"
                    *ngIf="
                        (currentRoute?.type ===
                            routeType.targetingSavedSearchResults ||
                            currentRoute?.type ===
                                routeType.targetingResults) &&
                        searchDirty &&
                        targetingSearch?.id
                    "
                    [label]="'Discover.targeting.actions.save' | localize"
                    [style]="buttonTypes.primary"
                    [options]="saveActions"
                    [panelPositionY]="'top'"
                    [panelPositionX]="'right'"
                ></agpr-split-button>
                <agpr-button
                    [id]="id + '.saveSearch'"
                    *ngIf="
                        (currentRoute?.type ===
                            routeType.targetingSavedSearchResults ||
                            currentRoute?.type ===
                                routeType.targetingResults) &&
                        !targetingSearch?.id
                    "
                    [style]="buttonTypes.primary"
                    label="Discover.targeting.actions.saveSearch"
                    (click)="openCreateDialog()"
                ></agpr-button>
                <agpr-button
                    [id]="id + '.importContacts'"
                    *ngIf="currentRoute?.type == routeType.privateContacts"
                    label="Discover.targeting.actions.importContacts"
                    [style]="buttonTypes.primaryB"
                    (click)="contactImporterVisible = true"
                ></agpr-button>
                <agpr-button
                    [id]="id + '.createContact'"
                    *ngIf="currentRoute?.type == routeType.privateContacts"
                    label="Discover.targeting.actions.createPrivate"
                    [style]="buttonTypes.primaryB"
                    (click)="createContact()"
                ></agpr-button>
                <agpr-split-button
                    *ngIf="
                        !this.targetingSearchService.mapView &&
                        currentRoute?.type == routeType.privateContacts
                    "
                    [style]="buttonTypes.primaryB"
                    [panelPositionY]="'top'"
                    [panelPositionX]="'right'"
                    [label]="'Discover.targeting.actions.actions'"
                    [options]="actions"
                ></agpr-split-button>
            </ng-template>
        </agpr-action-bar>
    </section>
    <aside
        class="agpr-targetingResults-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-rhp-contexts
            #sidebar
            [id]="'targetingResults_rhpContexts'"
            [overlayContainer]="overlayContainer"
            [(selectedTabIndex)]="rhpSelectedTabIndex"
            [hideOutletContactTabs]="targetingSearchService.mapView"
            [hiddenNoContentMessage]="
                results?.length === 0 &&
                addedResults?.length === 0 &&
                !summaryTab.selected &&
                !portfolioTab.selected
            "
        >
            <ng-container
                *ngIf="
                    results?.length === 0 &&
                    addedResults?.length === 0 &&
                    !summaryTab.selected &&
                    !portfolioTab.selected
                "
            >
                <agpr-message
                    *ngIf="targetingSearch?.searchMode == 'CONTACT'"
                    [severity]="messageSeverityEnum.noContent"
                >
                    <span>
                        {{
                            "Discover.targeting.result.noContactsFound"
                                | localize
                        }}
                    </span>
                </agpr-message>
                <agpr-message
                    *ngIf="targetingSearch?.searchMode == 'OUTLET'"
                    [severity]="messageSeverityEnum.noContent"
                >
                    <span>
                        {{
                            "Discover.targeting.result.noOutletsFound"
                                | localize
                        }}
                    </span>
                </agpr-message>
                <agpr-message
                    *ngIf="
                        targetingSearch?.searchMode !== 'OUTLET' &&
                        targetingSearch?.searchMode !== 'CONTACT'
                    "
                    [severity]="messageSeverityEnum.noContent"
                >
                    <span>
                        {{
                            "Discover.targeting.result.noMixedFound" | localize
                        }}
                    </span>
                </agpr-message>
            </ng-container>
            <agpr-entity-list-tab
                [id]="id + '.targetingRhpTab.entityResults'"
                [entityMode]="savedResultsEntity"
                [currentRoute]="currentRoute"
                [targetingList]="targetingList"
                [targetingMode]="true"
                [isDynamicEntityType]="true"
                [hiddenNoContentMessage]="true"
                [hidden]="!targetingSearchService.mapView"
                [tooltip]="
                    (savedResultsEntity === entityTypes.OUTLET
                        ? 'Discover.targeting.rhp.outletDetails'
                        : 'Discover.targeting.rhp.contactDetails'
                    ) | localize
                "
                (showRhpTakeOver)="spawnTakeover($event)"
                (updateRhpTitle)="sidebar.tabTitle = $event"
            ></agpr-entity-list-tab>
            @let isPrivateContactsRoute = currentRoute?.type === routeType.privateContacts;
            @let isTargetingListRoute = currentRoute?.type === routeType.targetingListSearchResult;
            <agpr-tab
                [id]="id + '.targetingRhpTab.targetingSearchSummary'"
                #summaryTab
                [hidden]="isPrivateContactsRoute"
                icon=" fa-file-lines"
                [showSpacer]="true"
                [tooltip]=" (isPrivateContactsRoute || isTargetingListRoute) ?
                    'Discover.targeting.rhp.tabs.listDetails' :
                    'Discover.targeting.rhp.tabs.searchSummary'"
            >
                <agpr-targeting-search-summary
                    [targetingSearch]="!(isPrivateContactsRoute || isTargetingListRoute) ? targetingSearch : null"
                    [targetingList]="targetingList"
                ></agpr-targeting-search-summary>
            </agpr-tab>
            <agpr-tab
                [id]="id + '.targetingRhpTab.portfolioTab'"
                #portfolioTab
                [hidden]="
                    currentRoute?.type !==
                        routeType.targetingListSearchResult ||
                    !isPortfolioEditor
                "
                icon="fa fa-leaf"
                tooltip="Portfolio metadata"
            >
                <agpr-portfolio-editor
                    [targetingList]="targetingList"
                ></agpr-portfolio-editor>
            </agpr-tab>
        </agpr-rhp-contexts>
    </aside>
</main>

<div
    *ngIf="contactEditorVisible"
    class="agpr-contactEditor-overlay"
    [@fade]="contactEditorVisible"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <agpr-contact-editor
        (hideContactEditor)="onContactEditorClose($event)"
    ></agpr-contact-editor>
</div>
<div
    *ngIf="contactImporterVisible"
    class="agpr-contactEditor-overlay"
    [@fade]="contactImporterVisible"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <agpr-contact-importer
        (hideContactImporter)="contactImporterVisible = false"
    ></agpr-contact-importer>
</div>
<agpr-portfolio-left-panel *ngIf="portfolioView"> </agpr-portfolio-left-panel>

<ng-template
    #listContextMenu
    let-className="className"
    let-selectedResult="selectedResult"
>
    @if (addToType === targetingAddToTypes.LIST) {
    <agpr-button
        *ngIf="targetingList"
        [id]="id + '_listContextMenu_remove'"
        [icon]="'fa-regular fa-duotone fa-square-xmark'"
        [tooltip]="
            'Discover.targeting.actions.removeFromList'
                | localize : { list: targetingList.name }
        "
        tooltipPosition="top"
        [class]="className"
        [initiallyFocusable]="false"
        [style]="buttonTypes.contextMenu"
        (click)="removeItemFromList(selectedResult)"
    ></agpr-button>
    <agpr-button
        *ngIf="selectedLists?.length"
        [id]="id + '_listContextMenu_add'"
        [icon]="'fa-regular fa-duotone fa-user-plus'"
        [tooltip]="selectedListsTooltip"
        tooltipPosition="top"
        [class]="className"
        [initiallyFocusable]="false"
        [style]="buttonTypes.contextMenu"
        (click)="addItemToLists(selectedResult)"
    ></agpr-button>
    } @if (addToType === targetingAddToTypes.DISTRIBUTION) {
    <agpr-button
        *ngIf="selectedResult?.showRemoveDistribution"
        [id]="id + '_listContextMenu_remove'"
        [icon]="'fa-regular fa-duotone fa-square-xmark'"
        [tooltip]="
            'Discover.targeting.actions.removeFromDist'
                | localize
                    : { dists: selectedResult?.removeDistributionTooltips }
        "
        tooltipPosition="top"
        [class]="className"
        [initiallyFocusable]="false"
        [style]="buttonTypes.contextMenu"
        (click)="removeItemFromDist(selectedResult)"
    ></agpr-button>
    <agpr-button
        *ngIf="selectedDistributions?.length"
        [id]="id + '_distributionContextMenu_add'"
        [icon]="'fa-kit-duotone fa-agpr-add-distribution'"
        [tooltip]="selectedDistributionsTooltip"
        tooltipPosition="top"
        [class]="
            className + ' agpr-targetingResults-listBuilder-addToDistButton'
        "
        [initiallyFocusable]="false"
        [style]="buttonTypes.contextMenu"
        (click)="addItemToDistributions(selectedResult)"
    ></agpr-button>
    }
</ng-template>
